// El área de influencia de un geoproceso usa zIndex 9999
// (GeoprocessingSelectionHandler) y la pluma/punto de origen usa 1000
// (geoprocessingsInteraction): las capas vulnerables de un resultado de
// geoproceso deben quedar siempre por delante de ambos.
export const GEOPROCESS_LAYER_ZINDEX = 10000;
export const GEOPROCESS_SELECTED_LAYER_ZINDEX = 10001;
